"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _compact = _interopRequireDefault(require("lodash/compact"));

var _get = _interopRequireDefault(require("lodash/get"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _breakpointObserver = require("@decisiv/breakpoint-observer");

var _composeReactRefs = _interopRequireDefault(require("@seznam/compose-react-refs"));

var _InputField = _interopRequireDefault(require("../../atoms/InputField"));

var _canUseDOM = _interopRequireDefault(require("../../utils/canUseDOM"));

var _focusWithoutScrolling = _interopRequireDefault(require("../../utils/focusWithoutScrolling"));

var _useClickOutside = _interopRequireDefault(require("../../utils/useClickOutside"));

var _useUniqueId = _interopRequireDefault(require("../../utils/useUniqueId"));

var _useUpdateEffect = _interopRequireDefault(require("../../utils/useUpdateEffect"));

var _DropdownList = _interopRequireDefault(require("../DropdownList"));

var _Button = require("../Button");

var _Target = _interopRequireDefault(require("./Target"));

var _propTypes2 = require("./propTypes");

var _schema = _interopRequireDefault(require("./schema"));

var _utils = require("./utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Select(props, ref) {
  var actions = props.actions,
      clearButtonLabel = props.clearButtonLabel,
      _props$hideClearButto = props.hideClearButton,
      hideClearButton = _props$hideClearButto === void 0 ? false : _props$hideClearButto,
      defaultValue = props.defaultValue,
      id = props.id,
      inputContainerRef = props.inputContainerRef,
      label = props.label,
      name = props.name,
      onChange = props.onChange,
      onClick = props.onClick,
      onHide = props.onHide,
      onKeyDown = props.onKeyDown,
      onShow = props.onShow,
      options = props.options,
      renderOptionLabel = props.renderOptionLabel,
      propValue = props.value,
      zIndex = props.zIndex,
      containerSelector = props.containerSelector;
  var fallbackSelectRef = (0, _react.useRef)(null);
  var finalSelectRef = ref || fallbackSelectRef;
  var inputId = (0, _useUniqueId.default)(id, 'select-');
  var listRef = (0, _react.useRef)(null);

  var _useBreakpointObserve = (0, _breakpointObserver.useBreakpointObserver)(),
      _useBreakpointObserve2 = _slicedToArray(_useBreakpointObserve, 2),
      popoverTargetRef = _useBreakpointObserve2[0],
      dimensions = _useBreakpointObserve2[1].dimensions;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPopoverVisible = _useState2[0],
      setIsPopoverVisible = _useState2[1]; // The selectedValue is the id of the selectedOption, or an empty string if none selected.


  var _useState3 = (0, _react.useState)(propValue || defaultValue || ''),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedValue = _useState4[0],
      setSelectedValue = _useState4[1]; // The selectedOption is the full object containing all data for the current selected value.
  // It should always be set based on the selectedValue.


  var _useState5 = (0, _react.useState)((0, _utils.getOptionFromOptions)(options, selectedValue) || {}),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedOption = _useState6[0],
      setSelectedOption = _useState6[1];
  /**
   * The current value and current option are saved independently, but must be kept in sync.
   * Using a single callback for this keeps it simple.
   */


  var updateSelected = (0, _react.useCallback)(function (selectedId) {
    setSelectedValue(selectedId);
    setSelectedOption((0, _utils.getOptionFromOptions)(options, selectedId) || {});
  }, [options, setSelectedOption, setSelectedValue]);
  /**
   * If the value prop changes, it should always override any locally maintained current values.
   * This allows the component to be controlled.
   */

  (0, _react.useEffect)(function () {
    if (typeof propValue === 'string' && propValue !== selectedValue) {
      updateSelected(propValue);
    }
  }, [propValue, selectedValue, updateSelected]);
  /**
   * Toggle the dropdown list.
   */

  var toggleIsPopoverVisible = (0, _react.useCallback)(function () {
    setIsPopoverVisible(!isPopoverVisible);
  }, [isPopoverVisible]);
  /**
   * Changing the selection also triggers some other actions, handled here.
   */

  var handleChangeValue = (0, _react.useCallback)(function (selectedIds) {
    var newCurrentValue = (0, _get.default)(selectedIds, 0, '');
    updateSelected(newCurrentValue);
    setIsPopoverVisible(false); // @ts-ignore

    (0, _focusWithoutScrolling.default)(finalSelectRef.current);
    onChange && onChange(newCurrentValue);
  }, [finalSelectRef, onChange, updateSelected]);
  /**
   * Clicking anywhere within the Select component (except the clear button) should toggle
   * the dropdown list.
   */

  var handleContainerClick = (0, _react.useCallback)(function (event) {
    toggleIsPopoverVisible();
    onClick && onClick(event);
  }, [onClick, toggleIsPopoverVisible]);
  /**
   * Pressing certain keys when focused on the Select component should trigger some actions.
   */

  var handleContainerKeyDown = (0, _react.useCallback)(function (event) {
    if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && !isPopoverVisible) {
      setIsPopoverVisible(true);
    }

    onKeyDown && onKeyDown(event);
  }, [isPopoverVisible, onKeyDown]);
  /**
   * When the dropdown is visible, certain some keyboard interactions should happen regardless
   * of where the user's focus is.
   */

  var handleDocumentKeyDown = (0, _react.useCallback)(function (event) {
    // "esc" = collapse dropdown, focus on select
    if (event.key === 'Escape') {
      setIsPopoverVisible(false); // @ts-ignore

      (0, _focusWithoutScrolling.default)(finalSelectRef.current);
    }
  }, [finalSelectRef]);
  /**
   * Allow some keyboard interactions to be based on the document instead of the input container.
   * This is useful for more global interactions, like closing the dropdown list.
   */

  (0, _react.useEffect)(function () {
    if (_canUseDOM.default && isPopoverVisible) {
      document.addEventListener('keydown', handleDocumentKeyDown);
    }

    return function () {
      document.removeEventListener('keydown', handleDocumentKeyDown);
    };
  }, [isPopoverVisible, handleDocumentKeyDown]); // When the dropdown is visible, clicking anywhere outside of the dropdown should close it.

  var handleClickOutsideList = (0, _react.useCallback)(function (event) {
    if (isPopoverVisible) {
      setIsPopoverVisible(false);
    }
  }, [isPopoverVisible]);
  (0, _useClickOutside.default)([listRef], handleClickOutsideList);
  var inputContainerRefs = (0, _compact.default)([inputContainerRef, popoverTargetRef]);
  /**
   * Triggers onShow/onHide callbacks representing wether the Popover is open or not.
   */

  (0, _useUpdateEffect.default)(function () {
    if (isPopoverVisible) {
      onShow && onShow();
    }

    if (!isPopoverVisible) {
      onHide && onHide();
    }
  }, [isPopoverVisible, onHide, onShow]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_InputField.default, _extends({}, props, {
    "aria-live": "assertive",
    cursor: "default",
    id: inputId,
    inputContainerRef: inputContainerRefs.length > 1 ? _composeReactRefs.default.apply(void 0, _toConsumableArray(inputContainerRefs)) : (0, _get.default)(inputContainerRefs, 0),
    onClick: handleContainerClick,
    onKeyDown: handleContainerKeyDown,
    ref: finalSelectRef,
    value: (0, _get.default)(selectedOption, 'label', '')
  }), function (_ref) {
    var ariaLabelledBy = _ref['aria-labelledby'],
        disabled = _ref.disabled,
        targetId = _ref.id,
        onBlurTarget = _ref.onBlur,
        onFocus = _ref.onFocus,
        readOnly = _ref.readOnly,
        targetRef = _ref.ref,
        value = _ref.value;
    var dropdownListId = "".concat(targetId, "-dropdown-list");
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Target.default, {
      "aria-haspopup": "listbox",
      "aria-labelledby": "".concat(ariaLabelledBy, " ").concat(targetId),
      "aria-owns": dropdownListId,
      clearButtonLabel: clearButtonLabel,
      disabled: disabled,
      hasClearButton: hideClearButton ? false : Boolean(selectedValue),
      id: targetId,
      inputFieldLabel: label,
      isPopoverVisible: isPopoverVisible,
      onBlur: onBlurTarget,
      onClear: handleChangeValue,
      onFocus: onFocus,
      readOnly: readOnly,
      ref: targetRef,
      type: "button"
    }, value), _react.default.createElement(_DropdownList.default, {
      actions: actions,
      "aria-labelledby": ariaLabelledBy,
      borderRadius: "0",
      id: dropdownListId,
      items: options,
      listRef: listRef,
      minWidth: "".concat((dimensions.width || 0) + 1, "px"),
      maxWidth: "unset",
      name: name,
      onChange: handleChangeValue,
      onHide: toggleIsPopoverVisible,
      onShow: toggleIsPopoverVisible,
      renderOptionLabel: renderOptionLabel,
      selectedIds: selectedValue,
      showArrow: false,
      target: popoverTargetRef,
      visible: isPopoverVisible,
      zIndex: zIndex,
      containerSelector: containerSelector
    }));
  }));
}

var SelectWithRef = (0, _react.forwardRef)(Select);
SelectWithRef.displayName = 'Select';
SelectWithRef.propTypes = _objectSpread({}, _schema.default.propTypes, {
  actions: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
    id: _propTypes.default.string.isRequired
  }))), _propTypes.default.shape({
    left: _propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
      id: _propTypes.default.string.isRequired
    }))),
    right: _propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
      id: _propTypes.default.string.isRequired
    })))
  })]),
  defaultValue: _propTypes2.valueValidator,
  icon: _propTypes.default.elementType,
  value: _propTypes2.valueValidator
});
SelectWithRef.defaultProps = {
  actions: undefined
};
var _default = SelectWithRef;
exports.default = _default;